import React, { useEffect, useState } from 'react';
import PageApp from '../../../Page';
import RangoEmpleadosInput, { RangoEmpleadosLabel } from '../../../../utils/RangoEmpleadosInput';
import { HomeOutlined, UnorderedListOutlined, DeleteOutlined } from '@ant-design/icons';
import { Form, Divider, Button, DatePicker, Checkbox, Select, Row, Col, Card, Space, Modal } from 'antd';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import { getList as getHorarios } from '../../../../apis/OdooScheduleApi';
import { getList as getDepartamentos } from '../../../../apis/OdooDepartamentoApi';
import { getList as getAreas } from '../../../../apis/AreasTrabajoApi';
import { getList as getPuestos } from '../../../../apis/OdooPuestoApi';
import { getAll as getSupervisores } from '../../../../apis/SupervisoresApi';
import { deleteMassiveAttendances } from '../../../../apis/OdooAttendanceApi';
import { message } from 'antd';
import dayjs from 'dayjs';

const { Option } = Select;
const { RangePicker } = DatePicker;

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Procesos</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <DeleteOutlined />
                <span>Borrado de Checadas</span>
            </>
        ),
    }
];

const EliminacionChecadasPage = () => {
    const [form] = Form.useForm();
    const [formFilters] = Form.useForm();
    const [period, setPeriod] = useState(null);
    const [anio, setAnio] = useState(null);
    const [fechaInicial, setFechaInicial] = useState(null);
    const [fechaFinal, setFechaFinal] = useState(null);
    const [disabledForm, setDisabled] = useState(true);

    // Estados para los catálogos
    const [horarios, setHorarios] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [areas, setAreas] = useState([]);
    const [supervisores, setSupervisores] = useState([]);

    const tiposReferencia = [
        { value: 'Generada', text: 'Generada' },
        { value: 'Capturada', text: 'Capturada' },
        { value: 'Importada', text: 'Importada' },
    ];

    useEffect(() => {
        (async () => {
            await getCatalogs();
        })();
    }, []);

    const getCatalogs = async () => {
        const responseHorarios = await getHorarios();
        if (responseHorarios.ok) {
            setHorarios(responseHorarios.payload);
        }

        const responseDepartamentos = await getDepartamentos();
        if (responseDepartamentos.ok) {
            setDepartamentos(responseDepartamentos.payload);
        }

        const responseAreas = await getAreas();
        if (responseAreas.ok) {
            setAreas(responseAreas.payload);
        }

        const responseSupervisores = await getSupervisores();
        if (responseSupervisores.ok) {
            setSupervisores(responseSupervisores.payload);
        }

        const responsePuestos = await getPuestos();
        if (responsePuestos.ok) {
            setPuestos(responsePuestos.payload);
        }
    };

    const onBlurHeader = async (values, periodData) => {
        if (values?.anio && periodData) {
            setAnio(values.anio);
            setPeriod(periodData);
            setDisabled(false);

            if (periodData.periodoCompleto?.fecha_inicial && periodData.periodoCompleto?.fecha_final) {
                const fechaIni = dayjs(periodData.periodoCompleto.fecha_inicial);
                const fechaFin = dayjs(periodData.periodoCompleto.fecha_final);
                setFechaInicial(fechaIni);
                setFechaFinal(fechaFin);
                form.setFieldsValue({
                    rango_fechas: [fechaIni, fechaFin]
                });
            }
        } else {
            setAnio(null);
            setPeriod(null);
            setDisabled(true);
            setFechaInicial(null);
            setFechaFinal(null);
            form.resetFields();
        }
    };

    const onChangeRangoFechas = (dates) => {
        if (dates && dates.length === 2) {
            setFechaInicial(dates[0]);
            setFechaFinal(dates[1]);
        } else {
            setFechaInicial(null);
            setFechaFinal(null);
        }
    };

    const onEliminarChecadas = async () => {
        try {
            const values = await form.validateFields();
            const filters = await formFilters.getFieldsValue();

            // Validar que al menos un checkbox esté marcado
            const tieneAlgunCheckbox = values.registrar_entrada ||
                values.registrar_salida ||
                values.dia_habil ||
                values.descanso1 ||
                values.descanso2;

            if (!tieneAlgunCheckbox) {
                message.warning('Debe seleccionar al menos una opción de registro o tipo de día');
                return;
            }

            // Validar fechas
            if (!fechaInicial || !fechaFinal) {
                message.warning('Debe seleccionar un rango de fechas válido');
                return;
            }

            if (filters.empleado_rango && filters.empleado_rango.trim()) {
                const rangoPattern = /^\s*(\d+\s*-\s*\d+|\d+)(\s*,\s*(\d+\s*-\s*\d+|\d+))*\s*$/;
                if (!rangoPattern.test(filters.empleado_rango.trim())) {
                    message.warning('El formato de rango de empleados no es válido. Use el formato: 1-7, 50, 150, 200-300');
                    return;
                }
            }

            // Mostrar modal de confirmación
            Modal.confirm({
                title: '¿Está seguro de eliminar las checadas?',
                content: 'Esta acción no se puede deshacer. Las checadas que cumplan con los filtros especificados serán eliminadas permanentemente.',
                okText: 'Sí, eliminar',
                okType: 'danger',
                cancelText: 'Cancelar',
                onOk: async () => {
                    // Construir el payload
                    const payload = {
                        fecha_inicial: fechaInicial.format('YYYY-MM-DD'),
                        fecha_final: fechaFinal.format('YYYY-MM-DD'),
                        registrar_entrada: values.registrar_entrada || false,
                        registrar_salida: values.registrar_salida || false,
                        dia_habil: values.dia_habil || false,
                        descanso1: values.descanso1 || false,
                        descanso2: values.descanso2 || false,
                    };

                    // Agregar filtros solo si tienen valor
                    if (filters.horario_id) {
                        payload.horario_id = filters.horario_id;
                    }
                    if (filters.puesto_id) {
                        payload.job_id = filters.puesto_id;
                    }
                    if (filters.departamento_id) {
                        payload.departamento_id = filters.departamento_id;
                    }
                    if (filters.area_id) {
                        payload.area_id = filters.area_id;
                    }
                    if (filters.supervisor_id) {
                        payload.supervisor_id = filters.supervisor_id;
                    }
                    if (filters.tipo_referencia) {
                        payload.tipo_referencia = filters.tipo_referencia;
                    }

                    if (filters.empleado_rango && filters.empleado_rango.trim()) {
                        payload.empleado_rango = filters.empleado_rango.trim();
                    }

                    // Mostrar loading
                    const hide = message.loading('Eliminando checadas...', 0);

                    try {
                        const response = await deleteMassiveAttendances(payload);

                        hide();

                        if (response.ok) {
                            const result = response.payload;
                            message.success(
                                `${result.message}. Empleados procesados: ${result.empleados_procesados}, Checadas eliminadas: ${result.checadas_eliminadas}`,
                                5
                            );

                            // Limpiar formulario después del éxito
                            form.resetFields(['registrar_entrada', 'registrar_salida', 'dia_habil', 'descanso1', 'descanso2']);
                        } else {
                            message.error('Error al eliminar las checadas');
                        }
                    } catch (error) {
                        hide();
                        console.error('Error al eliminar checadas:', error);
                        message.error(error.message || 'Error al eliminar las checadas');
                    }
                }
            });

        } catch (error) {
            console.error('Error al validar:', error);
            message.error('Por favor complete todos los campos requeridos');
        }
    };

    return (
        <PageApp
            routes={routes}
            title={'Borrado de Checadas'}
        >
            <>
                <AnioPreNomina
                    onBlur={onBlurHeader}
                    form={form}
                    disabledForm={false}
                />
                <Divider />

                <Form
                    layout="vertical"
                    form={form}
                    disabled={disabledForm}
                >
                    <Card title="Configuración de Eliminación" style={{ marginBottom: 16 }}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name="rango_fechas"
                                    label="Rango de Fechas"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona el rango de fechas',
                                        },
                                    ]}
                                >
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        onChange={onChangeRangoFechas}
                                        placeholder={['Fecha Inicial', 'Fecha Final']}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item label="Opciones de Filtrado">
                                    <Space direction="horizontal" size="large">
                                        <Form.Item name="registrar_entrada" valuePropName="checked" noStyle>
                                            <Checkbox>Con Entrada</Checkbox>
                                        </Form.Item>
                                        <Form.Item name="registrar_salida" valuePropName="checked" noStyle>
                                            <Checkbox>Con Salida</Checkbox>
                                        </Form.Item>
                                        <Form.Item name="dia_habil" valuePropName="checked" noStyle>
                                            <Checkbox>Día Hábil</Checkbox>
                                        </Form.Item>
                                        <Form.Item name="descanso1" valuePropName="checked" noStyle>
                                            <Checkbox>Descanso 1</Checkbox>
                                        </Form.Item>
                                        <Form.Item name="descanso2" valuePropName="checked" noStyle>
                                            <Checkbox>Descanso 2</Checkbox>
                                        </Form.Item>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    <Card title="Filtros" style={{ marginBottom: 16 }}>
                        <Form form={formFilters} layout="vertical">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        name="horario_id"
                                        label="Horario"
                                    >
                                        <Select
                                            placeholder="Selecciona un horario"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {horarios.map((item) => (
                                                <Option key={item.id} value={item.id}>
                                                    {item.codigo_corto}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="puesto_id"
                                        label="Puesto"
                                    >
                                        <Select
                                            placeholder="Selecciona un puesto"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {puestos.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.text}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="departamento_id"
                                        label="Departamento"
                                    >
                                        <Select
                                            placeholder="Selecciona un departamento"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {departamentos.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.text}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        name="area_id"
                                        label="Área"
                                    >
                                        <Select
                                            placeholder="Selecciona un área"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {areas.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.text}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="supervisor_id"
                                        label="Supervisor"
                                    >
                                        <Select
                                            placeholder="Selecciona un supervisor"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {supervisores.map((item) => (
                                                <Option key={item.id} value={item.id}>
                                                    {item.nombre}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="tipo_referencia"
                                        label="Tipo de Checada"
                                    >
                                        <Select
                                            placeholder="Selecciona tipo (por defecto: Generada)"
                                            allowClear
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {tiposReferencia.map((item) => (
                                                <Option key={item.value} value={item.value}>
                                                    {item.text}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                name="empleado_rango"
                                label={<RangoEmpleadosLabel />}
                            >
                                <RangoEmpleadosInput />
                            </Form.Item>
                        </Form>
                    </Card>

                    <Row>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Space>
                                <Button onClick={() => {
                                    form.resetFields();
                                    formFilters.resetFields();
                                }}>
                                    Limpiar
                                </Button>
                                <Button
                                    type="primary"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={onEliminarChecadas}
                                    disabled={disabledForm}
                                >
                                    Eliminar Checadas
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </>
        </PageApp>
    );
};

export default EliminacionChecadasPage;